import { loader } from "graphql.macro";
import client from "graphql/client";
import { LOAD_AI_CONFIG } from "redux/types";
import { snackbarError } from "shared/redux/actions/Snackbar";

const loadBookAIConfigurationQuery = loader("graphql/queries/configAI/fetchConfigAI.graphql");

export const loadConfigAI = (bookId) => {
    return async (dispatch) => {
        try {

            const { data } = await client.query({
                query: loadBookAIConfigurationQuery,
                variables: { bookId },
                fetchPolicy: "network-only",
            });


            dispatch({
                type: LOAD_AI_CONFIG,
                payload: data.bookAIConfiguration,
            });

        } catch (error) {
            console.error("Failed to load AI configuration:", error);
            dispatch(snackbarError("Failed to load AI configuration"));
        }
    };
};